module.exports = __webpack_public_path__ + "static/media/twitterThumbnail-Edu-600X310.3e6809ca.png";